module.exports = __webpack_public_path__ + "img/fence.d7a20687.svg";